/* One strand: rows of subjects, grouped by area.
   OWNED BY ITEM 4 OF docs/plan/00-prestavba-2026-08.md. */

import { useParams } from "react-router-dom";
import { covers } from "../../lib/covers";
import { useI18n } from "../../lib/i18n";
import { usePortal } from "../../lib/portal";
import { useIndex, subjectsIn } from "../../lib/hooks";
import { Billboard, Crumbs, Row, Tile } from "./Tile";
import { NotFound } from "../NotFound";
import { plural } from "./plural";

export function StrandPage() {
  const { strand = "" } = useParams();
  const { t, ui, href } = useI18n();
  const { taxonomy } = usePortal();
  const { data: index } = useIndex();
  if (!taxonomy) return null;

  const s = taxonomy.strands[strand];
  if (!s) return <NotFound />;

  const rows = index ? subjectsIn(index, strand, Object.keys(taxonomy.subjects)) : [];

  return (
    <div className="catalog">
      <Crumbs parts={[{ label: ui("nav.home"), to: href("/") }, { label: t(s.short) }]} />
      <Billboard art={covers.strand(strand)} eyebrow={ui("strand.eyebrow")}
                 title={t(s.name)} lead={t(s.who)} />
      {Object.entries(taxonomy.areas).map(([area, name]) => {
        const inArea = rows.filter((r) => taxonomy.subjects[r.id]?.area === area);
        if (!inArea.length) return null;
        return (
          <Row key={area} title={t(name)} count={plural(
            inArea.reduce((sum, r) => sum + r.count, 0), ui)}>
            {inArea.map((r) => (
              <Tile key={r.id} to={href(`/s/${strand}/${r.id}`)}
                    art={covers.subject(r.id, { strand, years: s.years }, taxonomy.subjects)}
                    title={taxonomy.subjects[r.id]!.name}
                    foot={plural(r.count, ui)} />
            ))}
          </Row>
        );
      })}
      {rows.length === 0 ? <p className="cat-empty">{ui("strand.empty")}</p> : null}
    </div>
  );
}
